import { gql, useMutation } from 'urql';
import { InvitationStatusEnum } from '@shared/hooks/useFetchInviteQrCode';

const RESPOND_INVITE_MUTATION = gql`
  mutation AcceptInvite($inviteHash: String!, $accepted: Boolean!) {
    acceptInvite(inviteHash: $inviteHash, accepted: $accepted) {
      success
      message
      ticketSent
      ticketId
      eventName
      dateStart
      dateEnd
      invitationStatus
      inviteAcceptionInfo
    }
  }
`;

type RespondInviteVariables = { inviteHash: string; accepted: boolean };

export interface RespondInviteData {
  acceptInvite: {
    success: boolean;
    message: string;
    ticketSent: boolean;
    ticketId: number | null;
    eventName: string | null;
    dateStart: string | null;
    dateEnd: string | null;
    invitationStatus: InvitationStatusEnum;
    inviteAcceptionInfo: string | null;
  };
}

export const useRespondInvite = () => {
  const [result, execute] = useMutation<RespondInviteData, RespondInviteVariables>(RESPOND_INVITE_MUTATION);

  const respond = (inviteHash: string, accepted: boolean) => execute({ inviteHash, accepted });
  const accept = (inviteHash: string) => respond(inviteHash, true);
  const decline = (inviteHash: string) => respond(inviteHash, false);

  return {
    accept,
    decline,
    respond,
    data: result.data,
    fetching: result.fetching,
    error: result.error,
  };
};

export default useRespondInvite;
